import React from "react";
import { styles } from "./element";
import PropTypes from "prop-types";
import { Header, Icon } from "semantic-ui-react";

const HomeHeader = ({ icon, head, subhead, mainHead, desc, ...props }) => (
  <Header
    className={mainHead ? "home_header" : "home_header"}
    {...props}
    style={styles}
  >
    {icon ? (
      <Icon.Group>
        <Icon fitted name={icon} />
        {head}
      </Icon.Group>
    ) : (
      head
    )}
    <Header.Subheader
      className={mainHead ? "home_subheader home_subheader2" : "home_subheader"}
      content={subhead}
      {...props}
      style={styles}
    />
    {desc ? (
      <Header.Subheader
        className={"home_subheader"}
        content={desc}
        {...props}
        style={styles}
      />
    ) : null}
  </Header>
);

HomeHeader.propTypes = {
  head: PropTypes.any,
  subhead: PropTypes.any,
  desc: PropTypes.any,
  icon: PropTypes.any,
};

export default HomeHeader;
